const contentBarHeight = 64;
const heightOffset = 64;

export {
	contentBarHeight,
	heightOffset
}